import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { FeatureToolTipItem, FeatureTooltipService } from './feature-tooltip.service';

@Component({
    selector: 'ohp-feature-tooltip-container',
    templateUrl: './feature-tooltip-container.component.html'
})
export class FeatureTooltipContainerComponent implements OnInit, OnDestroy {
    public tooltips: Array<FeatureToolTipItem>;

    private tooltipSubscription: Subscription;

    constructor(private readonly featureTooltipService: FeatureTooltipService) { }

    public ngOnInit() {
        this.tooltipSubscription = this.featureTooltipService.tooltips.subscribe(newToolTips => {
            this.tooltips = Array.from(newToolTips);
        });
    }

    public ngOnDestroy() {
        if (this.tooltipSubscription) {
            this.tooltipSubscription.unsubscribe();
        }
    }

    public trackByIndex(index: number) {
        return index;
    }
}
